// extracted by mini-css-extract-plugin
export default {"detailsBtn":"ContactRowBig_detailsBtn__+Uej-"};